import { IState } from 'legacy/lut/store'

export const selectGlobalPartnerState = (state: IState) => state.globalPartner
